import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import ReactPaginate from 'react-paginate'
import Select from 'react-select';
import Moment, { defaultFormat } from 'moment';
import { ControlLabel, Form, FormGroup, FormControl, Row, Col, Button, Pagination, Tabs, Tab } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import HrStore from '../../../stores/HrStore'
import ReportSummaryOT from './ReportSummaryOT'
import ReportSummaryNormalAbsence from './ReportSummaryNormalAbsence'
import ReportSummaryDeductionAbsence from './ReportSummaryDeductionAbsence'
import ReportSummarySlip from './ReportSummarySlip';

class ReportSummary extends Component {

  constructor(...args) {
    super(...args)

    this.state = {loading:false,tabIndex:0}
  }  

  componentDidMount() {
		//this.refs.reportSummarySlip.loadData()
  	// this.refs.reportSummaryOT.loadData()
  	// this.refs.reportSummaryNormalAbsence.loadData()
  	// this.refs.reportSummaryDeductionAbsence.loadData()
  }

  onTabsSelect(e) {
  	// if (e===1) {
  	// 	this.refs.reportSummaryOT.loadData()
  	// } else if (e===2) {
  	// 	this.refs.reportSummaryNormalAbsence.loadData()
  	// } else if (e===3) {
  	// 	this.refs.reportSummaryDeductionAbsence.loadData()
		// }
		this.setState({tabIndex:e})
  }

  /*
  renderTabs() {
  	let icon = (<div><FontAwesome name='trophy' /> OT รวม</div>)
  	let icon1 = (<div><FontAwesome name='user' /> ลางานทั่วไป</div>)
  	let icon2 = (<div><FontAwesome name='frown-o' /> ลางานหักเงินเดือน</div>)	
  	return(
  		<Tabs defaultActiveKey={1} id="controlled-tab-example" onSelect={this.onTabsSelect.bind(this)}>
		  <Tab eventKey={1} title={icon}>
		    <ReportSummaryOT
		    	ref={'reportSummaryOT'}
		    />
		  </Tab>
		  <Tab eventKey={2} title={icon1}>
		    <ReportSummaryNormalAbsence
		    	ref={'reportSummaryNormalAbsence'}
		    />
		  </Tab>
		  <Tab eventKey={3} title={icon2}>
		    <ReportSummaryDeductionAbsence
		    	ref={'reportSummaryDeductionAbsence'}
		    />
		  </Tab>
		</Tabs>
  	)
  }
  */	

  render() {
	let icon0 = (<div><FontAwesome name='money' /> รายงานค่าแรง</div>)
  	let icon = (<div><FontAwesome name='trophy' /> OT รวม</div>)
  	let icon1 = (<div><FontAwesome name='user' /> ลางานทั่วไป</div>)
	let icon2 = (<div><FontAwesome name='frown-o' /> ลางานหักเงินเดือน</div>)	
	let {tabIndex} = this.state
  	return(
  		<Tabs defaultActiveKey={tabIndex} id="controlled-tab-example" onSelect={this.onTabsSelect.bind(this)}>
		  <Tab eventKey={0} title={icon0}>
		    <ReportSummarySlip
		    	show={tabIndex===0}
		    />
		  </Tab>			
		  <Tab eventKey={1} title={icon}>
		    <ReportSummaryOT
		    	show={tabIndex===1}
		    />
		  </Tab>
		  <Tab eventKey={2} title={icon1}>
		    <ReportSummaryNormalAbsence
		    	show={tabIndex===2}
		    />
		  </Tab>
		  <Tab eventKey={3} title={icon2}>
		    <ReportSummaryDeductionAbsence
		    	show={tabIndex===3}
		    />
		  </Tab>
		</Tabs>
  	)
  }
}

export default ReportSummary;


// WEBPACK FOOTER //
// ./src/view/hr/report/ReportSummary.js